import hasPastError from 'utils/errors/methods/hasPastError';
import filterTimeErrorsForEconomyMode from 'utils/errors/methods/filterTimeErrorsForEconomyMode';

export default {
  hasPastError,
  filterTimeErrorsForEconomyMode,
};
